import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { InvoiceNumberBody, ILienReleaseLabel } from '../../../core/models';
import { SelfUtilityService } from '../../../core/services/self-utility.service';
import { UserService } from '../../../core/services/user.service';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { AppNotifyService } from '../../../core/services/app-notify.service';
import { NotifyType } from '../../../core/enums/NotifyType';

@Component({
  selector: 'app-lien-release',
  templateUrl: './lien-release.component.html',
  styleUrls: ['./lien-release.component.scss']
})
export class LienReleaseComponent implements OnInit {

  @ViewChild('panelbar', { static: false }) panel;
  public expandMode: number = PanelBarExpandMode.Multiple;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;
  disabled: boolean = true;
  lblText: ILienReleaseLabel;
  lienReleaseForm: FormGroup;
  lienDownloadForm: FormGroup;
  isNotaryChecked: boolean;
  isTermsChecked: boolean;
  getLienType: [];
  isEnabled: boolean = false;
  isDisabled:  true;
  paidByCustomerSelected = true;
  isLienNotarySubmitted = false;
  public maxDate = new Date();
  constructor(private formBuilder: FormBuilder,
    private userService: UserService,
    private selfServiceUtility: SelfUtilityService, private languageTranslationService: LanguageTranslationService, private appNotifyService: AppNotifyService) { }

  ngOnInit() {
   
    this.lienReleaseForm = this.formBuilder.group({
      invoiceNumber: new FormControl(),
      lienType: new FormControl(),
      progressLienThruDate: new FormControl(),
      notary: new FormControl(),
      faxNumber: new FormControl(),
      termsConditions: new FormControl()
    })
    this.lienDownloadForm = this.formBuilder.group({
      paidType: new FormControl(),      
      paidDefaultAmount: new FormControl({ value: "*PAID*", disabled: true }),
      paidByOwnerAmount: new FormControl({ value: '', disabled: true }),
      paidByCustomerAmount: new FormControl()
    })
    this.LoadLanguageTranslationData();
    var todaysDate = new Date();
    this.maxDate.setDate(todaysDate.getDate() - 1);
    this.isLienNotarySubmitted = false;
    this.lienDownloadForm.get('paidType')?.setValue('paidDefault');
  }
  //#region Language translate
  LoadLanguageTranslationData() {
    const controlNameList = [{ controlName: "acceptTermsAndConditionsLbl" },
    { controlName: "businessDaysToProcessLbl" },
    { controlName: "cancelButtonLbl" },
    { controlName: "faxLbl" },
    { controlName: "invoiceNumberLbl" },
    { controlName: "lienReleaseLbl" },
    { controlName: "lienReleaseTermsAndConditionsLbl" },
    { controlName: "lienReleaseTermsAndConditionsTex1tLbl" },  
    { controlName: "notaryRequiredLbl" },
    { controlName: "selectLienTypeLbl" },
    { controlName: "submitButtonLbl" },
    { controlName: "progressLienThruDateLbl" },
    { controlName: "invalidInvoiceNumberLbl" },
    { controlName: "paidDefaultLbl" },
    { controlName: "paidByKawneerLbl" },
    { controlName: "noSelectionTextLbl" },
    { controlName: "continueDownloadLbl" },
    { controlName: "invoiceDetailTitleLbl" },
    { controlName: "downoadTitleLbl" },
    { controlName: "continueLbl" },
    { controlName: "lienNotarySubmittedTextLbl" },
    { controlName: "lienReleaseTextLbl" }
    ];

    const componentName = "lienRelease";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);    
    if (response.length > 0) {
      this.lblText = response[response.length - 1];
    }
    console.log(response);
  }

  //#endregion

  //#region label declaration
  public lienRelease = {
    confirmDialogOpened: false,
    invoiceNumberLbl: "Invoice Number",
    selectLienTypeLbl: "Select Lien Type",
    progressLienThruDateLbl: "Progress Lien Release Thru Date",
    notaryRequiredLbl: "Notary Required?  (3-5 Business Days to Process)",
    businessDaysToProcessLbl: " (3-5 Business Days to Process)",
    faxLbl: "Fax Number",
    continueLbl: "Continue",
    invalidInvoiceNumberLbl: "Invalid invoice number",
    termsChecked: false,
    acceptTermsAndConditionsLbl: "I Accept Terms & Conditions",
    lienReleaseTermsAndConditionsLbl: "Kawneer Lien Release Terms and Conditions",
    lienReleaseTermsAndConditionsTex1tLbl: "In consideration for access to and use of Kawneer online lien release system, by clicking below you acknowledge and agree for yourself and on behalf of your company that all lien releases are provided without any representation or warranty, express or implied, on the part of the Kawneer or its parent company or any of their respective affiliates or representatives or employees. Lien release requirements may vary by country, state and local law and it is your responsibility to determine that a provided lien release meets these requirements and is suitable for your needs. You further agree that Kawneer, its parent company, and any of their respective affiliates or representatives or employees shall have no liability, under law or contract, for any loss or injury caused by use or attempted use of the lien release. Finally, you acknowledge and agree that in the event of a discrepancy between the lien release and any invoice(s) issued by Kawneer with respect to amounts owed, the invoices shall take precedence and control and the lien release shall serve no evidentiary purpose as between your company and Kawneer.",
    lienTypeData: [{ name: 'Progress Lien Release', value: 1 },
    { name: 'Final Lien Release', value: 2 }],
    showThruDate: false,
    isContinued: false,
    isEmptyInvoiceNumber: false,
    isInvoiceNumberInValid: false,
    paidDefaultLbl: "Amount Paid Default",
    paidByKawneerLbl: "Amount Paid By Kawneer",
    paidByCustomerLbl: "Amount Paid By",
    customerName: this.userService.readUserObject.customerName,
    noSelectionTextLbl: "If No Selection is made the default of *PAID* will apply.",
    continueDownloadLbl: "Continue with Download",
    cancelButtonLbl: "Cancel",
    invoiceDetailTitleLbl: "Invoice Detail",
    downoadTitleLbl: "Download",
    lienNotarySubmittedTextLbl: "Your request has been submitted and the Kawneer Credit Team will email your notarized Lien Release in 3-5 business days to the email address associated to your KawneerDirect account.",
    lienReleaseTextLbl: "Lien-Release",
    paidDefaultSelected: true,
    paidByOwnerSelected: false,
    paidByCustomerSelected: false,
    continueInProcess: false,
    downloadInProgress: false,
    isEmptyAmount: false,
    isSubmitted: false,    
    isEmptyLienThruDate: false   
  }
  //#region label declaration
  //public lienRelease = {
  //  confirmDialogOpened: false,
  //  invoiceNumber: "Invoice Number",
  //  lienType: "Lien Type Requested",
  //  progressLienThruDate: "Progress Lien Release Thru Date",
  //  notary: "Notary Required?  (3-5 Business Days to Process)",
  //  faxNumber: "Fax Number",
  //  continueLbl: "Continue",
  //  invalidInvoiceNumber:"Invalid invoice number",
  //  termsChecked:false,
  //  acceptTermsCondition: "I Accept Terms & Conditions",
  //  termsConditionHeading: "Kawneer Lien Release Terms and Conditions",
  //  termsConditionContent: "In consideration for access to and use of Kawneer online lien release system, by clicking below you acknowledge and agree for yourself and on behalf of your company that all lien releases are provided without any representation or warranty, express or implied, on the part of the Kawneer or its parent company or any of their respective affiliates or representatives or employees. Lien release requirements may vary by country, state and local law and it is your responsibility to determine that a provided lien release meets these requirements and is suitable for your needs. You further agree that Kawneer, its parent company, and any of their respective affiliates or representatives or employees shall have no liability, under law or contract, for any loss or injury caused by use or attempted use of the lien release. Finally, you acknowledge and agree that in the event of a discrepancy between the lien release and any invoice(s) issued by Kawneer with respect to amounts owed, the invoices shall take precedence and control and the lien release shall serve no evidentiary purpose as between your company and Kawneer.",
  //   lienTypeData: [{ name: 'Progress Lien Release', value: 1 },
  //    { name: 'Final Lien Release', value: 2 }],
  //  showThruDate: false,
  //  isContinued: false,
  //  isEmptyInvoiceNumber: false,
  //  isInvoiceNumberInValid:false,
  //  paidDefault: "Amount Paid Default",
  //  paidByKawneer: "Amount Paid By Kawneer",
  //  paidByCustomer: "Amount Paid By",
  //  customerName: this.userService.readUserObject.customerName,
  //  heading: "If No Selection is made the default of *PAID* will apply.",
  //  continueDownload: "Continue with Download",
  //  paidDefaultSelected: true,
  //  paidByOwnerSelected: false,
  //  paidByCustomerSelected: false,
  //  continueInProcess: false,
  //  downloadInProgress:false
  //}
  showFaxNumber() {
    this.isNotaryChecked = !this.isNotaryChecked;
  }
  showDownloadLienRelease() {
    this.isTermsChecked = !this.isTermsChecked;
  }
  selectLienType(event) {
    if (event.name == "Progress Lien Release") {
      this.lienRelease.showThruDate = true;
    } else {
      this.lienRelease.showThruDate = false;
      this.lienReleaseForm.controls.progressLienThruDate.reset();
      this.showDi = false;
      this.lienRelease.isEmptyLienThruDate = false;
    }
  }
  toggle(type) {
    if (type == 'paidByCustomer') {
      this.isEnabled = true;
      this.lienRelease.paidDefaultSelected = false;
      this.lienRelease.paidByOwnerSelected = false;
      this.lienRelease.paidByCustomerSelected = true;
      return;
    } else if (type == 'paidByOwner') {      
      this.lienRelease.paidDefaultSelected = false;
      this.lienRelease.paidByOwnerSelected = true;
      this.lienRelease.paidByCustomerSelected = false;
    }
    else { //default
      this.lienRelease.paidDefaultSelected = true;
      this.lienRelease.paidByOwnerSelected = false;
      this.lienRelease.paidByCustomerSelected = false;     

    }
    this.isEnabled = false;
    this.lienDownloadForm.controls.paidByCustomerAmount.reset();
    this.lienRelease.isEmptyAmount = false;
  }
 //#region
  showDi: boolean = false;
  public validateLienReleasePanel1(): boolean {
    let isValid = true;
    const controls = this.lienReleaseForm.controls;
    if (this.lienRelease.isContinued) {
      if (controls.invoiceNumber.value) {
        this.lienRelease.isEmptyInvoiceNumber = false;
        this.lienRelease.isInvoiceNumberInValid = false;
      } else {
        this.lienRelease.isEmptyInvoiceNumber = true;
        isValid = false;
      }
      if (this.lienRelease.showThruDate == true) {
        if (controls.progressLienThruDate.value && controls.progressLienThruDate.value < Date.now()) {
          this.lienRelease.isEmptyLienThruDate = false;
          this.showDi = false;
        } else {
          isValid = false;
          this.showDi = true;
          this.lienRelease.isEmptyLienThruDate = true;
        }
      }
      if (controls.termsConditions.value == true) {        
      } else {
        isValid = false;
      }
    }
    return isValid;
  }
  
  checkLienThruDate() {
    const controls = this.lienReleaseForm.controls;
    if (this.lienRelease.isContinued) {
      if (controls.progressLienThruDate.value && controls.progressLienThruDate.value < Date.now()) {
        this.lienRelease.isEmptyLienThruDate = false;
        this.showDi = false;
      }
      else {
        this.showDi = true;
        this.lienRelease.isEmptyLienThruDate = true;
      }
    } 
  }
  validateCustomerAmount() {
    if (this.lienRelease.isSubmitted == true) {
      const controls = this.lienDownloadForm.controls;
      if (controls.paidType.value == "paidByCustomer") {
        if (!controls.paidByCustomerAmount.value) {
          this.lienRelease.isEmptyAmount = true;
        } else {
          this.lienRelease.isEmptyAmount = false;
        }
      }
    }
    
  }
  //#endregion
  //#region Download lien release button operation
  downloadLienRelease() {
    this.lienRelease.isSubmitted = true;
    this.lienRelease.isContinued = true;
    if (!this.validateLienReleasePanel1()) {
      return;
    }
    this.DownloadLienReleasePDF();
  }
  DownloadLienReleasePDF() {
    const controls1 = this.lienReleaseForm.controls;
    const controls2 = this.lienDownloadForm.controls;
    var amount = "";
    if (controls2.paidType.value == "paidDefault") {
      amount = controls2.paidDefaultAmount.value;
    } else if (controls2.paidType.value == "paidByOwner") {
      amount = controls2.paidByOwnerAmount.value ? controls2.paidByOwnerAmount.value.toString() : "";
    } else if (controls2.paidType.value == "paidByCustomer") {
      if (!controls2.paidByCustomerAmount.value) {
        amount = '0';
        this.lienRelease.isEmptyAmount = true;
        return;
      }
      else
        amount = controls2.paidByCustomerAmount.value.toString();
      this.lienRelease.isEmptyAmount = false;
    }
    this.lienRelease.downloadInProgress = true;
    //const body: InvoiceNumberBody = {
    //  invoiceNumber: this.lienReleaseForm.controls.invoiceNumber.value.toString(),
    //  customerNumber: this.userService.readUserObject.customerNumber,
    //  date: this.lienReleaseForm.controls.progressLienThruDate.value 
    //}
    //this.selfServiceUtility.getDetailsByInvoiceNumber(body).subscribe(response => {
    //  if (response != null && response.isInvoiceValid == true) {
    //this.lienDownloadForm.controls.paidByOwnerAmount.setValue(response.grossAmount);
    //  } else {
    //    this.lienRelease.isInvoiceNumberInValid = true;
    //  }
  //});
        this.lienRelease.isInvoiceNumberInValid = false;
        this.isLienNotarySubmitted = false;
        
       
        const body = {
          invoiceNumber: controls1.invoiceNumber.value.toString(),
          lienType: controls1.lienType.value ? controls1.lienType.value.name : "",
          progressLienThruDate: formatDate(controls1.progressLienThruDate.value, 'MM/dd/yyyy', 'en-US'),
          notary: controls1.notary.value ? controls1.notary.value : false,
          faxNumber: (controls1.faxNumber.value ? controls1.faxNumber.value:0).toString(),
          paidType: controls2.paidType.value,
          paidAmount: amount,
          customerNumber: this.userService.readUserObject.customerNumber,
          userName: this.userService.readUserObject.userName
        }
        this.selfServiceUtility.downloadLienRelease(body).subscribe(response => {
          if (response && response.urlPath) {
            if (response.urlPath.includes("Invalid Invoice")) {
              this.lienRelease.isSubmitted = false;
              this.lienRelease.isEmptyAmount = false;
              this.lienRelease.downloadInProgress = false;
              this.lienRelease.isInvoiceNumberInValid = true;
            }
            else {
              if (body.notary) {
                this.isLienNotarySubmitted = true;
              } else {
                const linkSource = 'data:application/pdf;base64,' + response.urlPath;
                const downloadLink = document.createElement("a");
                const fileName = "LienRelease.pdf";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
                this.isLienNotarySubmitted = false;
              }
              this.resetLienReleaseForm(); 
            }
          } else {
            this.lienRelease.isSubmitted = false;
            this.lienRelease.isEmptyAmount = false;
            this.lienRelease.downloadInProgress = false;
            this.appNotifyService.notify(NotifyType.ERROR, 'Something went Wrong!');
          }
          
        });
        
    
   
  }
  //#endregion
  //#region Reset form
  resetLienReleaseForm() {
    this.lienRelease.downloadInProgress = false;
    this.lienRelease.isContinued = false;
    this.lienRelease.continueInProcess = false;
    this.lienRelease.isEmptyLienThruDate = false;
    this.lienRelease.isInvoiceNumberInValid = false;
    this.lienRelease.isEmptyAmount = false;
    this.lienRelease.isSubmitted = false;
    this.lienReleaseForm.reset();   
    this.lienRelease.showThruDate = false;
    this.showDi = false;
    this.isNotaryChecked = false;
  }
  closeLienReleaseNotaryPopup() {
    this.isLienNotarySubmitted = false;
  }
  //#endregion
  //#region panel change
  continueToDownload() {
    this.lienRelease.isContinued = true;    
    if (!this.validateLienReleasePanel1()) {
      return;
    }
    this.lienRelease.continueInProcess = true;    
    const body: InvoiceNumberBody = {
      invoiceNumber: this.lienReleaseForm.controls.invoiceNumber.value.toString(),
      customerNumber: this.userService.readUserObject.customerNumber,
      date: this.lienReleaseForm.controls.progressLienThruDate.value
    }    
    this.selfServiceUtility.getDetailsByInvoiceNumber(body).subscribe(response => {
      if (response!=null && response.isInvoiceValid == true) {
        this.lienRelease.isInvoiceNumberInValid = false;
        this.lienDownloadForm.controls.paidByOwnerAmount.setValue(response.grossAmount);
        this.panel.childrenItems.forEach(item => {
          if (item.expanded) {
            item.expanded = false;
            item.selected = false;
          }
        });
        this.panel.childrenItems[1].expanded = true;
        this.panel.childrenItems[1].selected = true;
      } else {
        this.lienRelease.isInvoiceNumberInValid = true;
      }
      this.lienRelease.continueInProcess = false;
      this.lienRelease.isEmptyLienThruDate = false;

    });
  } 

  //#endregion
}
